import React from "react";
import Navigation from "./Navigation";
let Header = () => {
  return (
    <div>
      <Navigation />
    </div>
  );
};
export default Header;
